import { useCallback, useEffect, useRef, useState } from 'react';

export default function useProcessingCloseGuard({ isProcessing, onClose }) {
  const [isWarningOpen, setIsWarningOpen] = useState(false);
  const closeArgumentsRef = useRef([]);

  useEffect(() => {
    if (isProcessing) return;
    closeArgumentsRef.current = [];
    setIsWarningOpen(false);
  }, [isProcessing]);

  const requestClose = useCallback((...closeArguments) => {
    if (!isProcessing) {
      onClose(...closeArguments);
      return;
    }

    closeArgumentsRef.current = closeArguments;
    setIsWarningOpen(true);
  }, [isProcessing, onClose]);

  const stay = useCallback(() => {
    closeArgumentsRef.current = [];
    setIsWarningOpen(false);
  }, []);

  const closeAnyway = useCallback(() => {
    const closeArguments = closeArgumentsRef.current;
    closeArgumentsRef.current = [];
    setIsWarningOpen(false);
    onClose(...closeArguments);
  }, [onClose]);

  return { requestClose, isWarningOpen, stay, closeAnyway };
}
